module.exports = __webpack_public_path__ + "images/icon/icon_24x24_stroke_close_default-7df06e98.svg";